import { Link } from "react-router-dom";
import { ChevronRight, Clock, Users } from "lucide-react";
import { useApp } from "../context/AppContext";

export function MissionCard({ m }) {
  const { isManager } = useApp();
  let status = null;
  if (m.state === "cancelled") status = <span className="rounded-full bg-slate-200 px-3 py-1 text-xs font-bold text-slate-600">Annulée</span>;
  else if (m.state === "done") status = <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-500">Terminée</span>;
  else if (m.is_mine) status = <span className="rounded-full bg-emerald-600 px-3 py-1 text-xs font-bold text-white">✅ Confirmée</span>;
  else if (m.filled) status = <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-600">✅ POURVUE</span>;
  else if (isManager) status = <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-bold text-amber-800">{m.dispo_count} disponible(s)</span>;
  else if (m.my_response === "dispo") status = <span className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-bold text-emerald-700">Tu es disponible</span>;
  else if (m.my_response === "indispo") status = <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-500">Pas disponible</span>;
  else status = <span className="rounded-full bg-teal-600 px-3 py-1 text-xs font-bold text-white">Nouvelle</span>;
  return (
    <Link to={`/missions/${m.id}`} data-testid={`mission-card-${m.id}`} className="card tap flex items-center gap-3 p-4 fade-up">
      <div className="min-w-0 flex-1">
        <div className="mb-1.5">{status}</div>
        <div className="truncate text-lg font-bold">{m.kind === "replacement" ? `🔁 Remplacement de ${m.replaced_name?.split(" ")[0] || ""}` : m.title}</div>
        {m.kind !== "replacement" && m.title !== m.home_name && <div className="truncate text-sm text-slate-500">{m.home_name}</div>}
        <div className="text-sm font-semibold text-slate-700">{m.label_date}</div>
        <div className="mt-0.5 flex gap-4 text-sm text-slate-500">
          <span className="flex items-center gap-1 font-mono"><Clock className="h-3.5 w-3.5" />{m.start ? `${m.start} → ${m.end}` : "Journée"}</span>
          <span className="flex items-center gap-1"><Users className="h-3.5 w-3.5" />{m.needed}</span>
        </div>
        {isManager && m.assigned_names.length > 0 && <div className="mt-1 text-sm font-semibold text-emerald-700">→ {m.assigned_names.join(", ")}</div>}
      </div>
      <ChevronRight className="h-5 w-5 shrink-0 text-slate-300" />
    </Link>
  );
}
